import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import "datatables.net-dt";
import $ from "jquery";
import { baseURL } from "../../axios/common";

const SuggestionSports = () => {
  const [sportSuggestions, setSportSuggestions] = useState([]);

  useEffect(() => {
    fetchSportSuggestions();
  }, []);

  useEffect(() => {
    if (sportSuggestions.length) {
      if (!$.fn.DataTable.isDataTable("#SportSuggestionsTable")) {
        $("#SportSuggestionsTable").DataTable();
      }
    }
  }, [sportSuggestions]);

  // Fetch Sport Suggestions List using GET method
  const fetchSportSuggestions = async () => {
    try {
      const response = await axios.get(
        baseURL + "admin/getSportSuggestions",
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      
      // Log the API response to verify the structure
      console.log("API Response:", response.data);

      // Assuming the response contains a 'data' field that holds the array of suggestions
      setSportSuggestions(response.data.data); 
    } catch (error) {
      console.error("Error fetching sport suggestions:", error);
    }
  };

  return (
    <div>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid"></div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h2 className="card-title">Suggestions</h2>
                    </div>
                    <div className="card-body">
                      <table id="SportSuggestionsTable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Suggested Sports</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sportSuggestions.map((suggestion, index) => (
                            <tr key={suggestion.id}>
                              <td>{index + 1}</td>
                              <td>{suggestion.name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default SuggestionSports;
